import Container from "../Container";
import {TableCellKey, TableCellValue} from "../../designSystem/Table";

export interface MembershipRecapProps {
    birthName?: string;
    birthCity: string;
    address: string;
    addressDetails?: string;
    zipCode: string;
    city: string;
    country: string;
    phone: string;
    email: string;
    discipline: string;
    activity: string;
    handi?: boolean;
    affiliation: string;
    modify?: () => void;
}

const MembershipRecap = (props: MembershipRecapProps) => {
    return (
      <Container containerTitle={"Informations pratiquant"}>
        <table>
          <tbody>
            {props.birthName && (
              <tr>
                <TableCellKey>Nom de naissance</TableCellKey>
                <TableCellValue>{props.birthName}</TableCellValue>
              </tr>
            )}
            <tr>
              <TableCellKey>Commune de naissance</TableCellKey>
              <TableCellValue>{props.birthCity}</TableCellValue>
            </tr>
            <tr>
              <TableCellKey>Adresse</TableCellKey>
              <TableCellValue>
                {props.address}, {props.zipCode}, {props.city}, {props.country}
              </TableCellValue>
            </tr>
            {props.addressDetails && (
              <tr>
                <TableCellKey>Complément d'adresse</TableCellKey>
                <TableCellValue>{props.addressDetails}</TableCellValue>
              </tr>
            )}
            <tr>
              <TableCellKey>Email</TableCellKey>
              <TableCellValue>{props.email}</TableCellValue>
            </tr>
            <tr>
              <TableCellKey>Pratique principale</TableCellKey>
              <TableCellValue>{props.discipline}</TableCellValue>
            </tr>
            <tr>
              <TableCellKey>Type de pratique</TableCellKey>
              <TableCellValue>{props.activity}</TableCellValue>
            </tr>
            {props.handi !== undefined &&
              <tr>
                <TableCellKey>En situation de handicap</TableCellKey>
                <TableCellValue>{!!props.handi ? "Oui" : "Non"}</TableCellValue>
              </tr>
            }
            <tr>
              <TableCellKey>Rattachement</TableCellKey>
              <TableCellValue>{props.affiliation}</TableCellValue>
            </tr>
          </tbody>
        </table>
        {props.modify && (
          <div
            className={"flex mt-4 justify-center text-blue cursor-pointer"}
            onClick={props.modify}
          >
            Modifier
          </div>
        )}
      </Container>
    );
}

export default MembershipRecap;